<template>
  <div class="tw-overflow-x-hidden">
    <Sidebar :is-at-header-section="isAtHeaderSection" />
    <Header @section-visible="isAtHeaderSection = $event" />
    <AboutUs :show-sidebar="isAtHeaderSection" />
    <WhatWeDo :card-datas="wordpressData.services" />
    <OurWork
      v-if="works.length > 0"
      :key="workKey"
      ref="ref5"
      s
      :dark-mode="true"
      :grid-items="works_items"
    />
    <!-- <WelcomePage /> -->
    <Footer v-model:show-cookie-policy="showCookiePolicy" :expertises="expertises" :works="works" />
    <CookieBanner
      v-model:show="showCookieBanner"
      @update:show="showCookieBanner = $event"
      @click-manage-my-preferences="showCookieBannerModal = true"
      @show-cookie-policy="showCookiePolicy = true"
    />
    <CookieSettingModal v-model:show="showCookieBannerModal" @update:show="showCookieBannerModal = $event" />
  </div>
</template>

<script setup lang="ts">
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

import 'animate.css';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { uuid } from 'vue3-uuid';
import AboutUs from '../components/home/about-us.vue';
import Header from '../components/home/header.vue';
import OurWork from '../components/home/our-work.vue';
import Sidebar from '../components/home/sidebar.vue';
import WhatWeDo from '../components/home/what-we-do.vue';
import CookieBanner from '../components/shared/CookieBanner.vue';
import CookieSettingModal from '../components/shared/CookieSettingModal.vue';
import Footer from '../components/shared/Footer.vue';
import { Expertise } from '../model/interfaces/interfaces';
import { Work } from '../model/interfaces/WorkInterface';
import { getWorks, setupOrientationListener } from '../support/helper';
// Define a ref to hold the fetched works
// Function to fetch works from the 'our-works' API

withDefaults(defineProps<{
  wordpressData?: any | null,
}>(), {
  wordpressData: null,
});

const workKey = ref(uuid.v4());
const works_items = ref<Array<Work>>([]);
const expertises = ref<Array<Expertise>>([]);
const orientation = ref('portrait');

const works = computed(() => works_items.value);

const showCookieBanner = ref(true);
const showCookieBannerModal = ref(false);
const showCookiePolicy = ref(false);

// sidebar
const isAtHeaderSection = ref(true);

function fetchWorks() {
  // axios
  //   .get(cdn("json/home/dummy-works.json"))
  //   .then((response) => {
  //     works_items.value = response.data; // Update works_items with fetched data
  //   })
  //   .catch((error) => {
  //     console.error("There was an error fetching the data:", error);
  //   });
  getWorks().then((response) => {
    works_items.value = response?.works ?? [];
  }).catch((error) => {
    console.error('There was an error fetching the data:', error);
  });
}

// TODO: Get real data from API
function getExpertiseData() {
  expertises.value = [
    {
      title: 'Artificial Intelligence',
      type: 'ai',
      tagline: 'Revolutionising Software Engineering.',
      description: 'We harness the power of AI to create data-driven solutions that personalise user engagement and humanise the brand experience.',
      url: 'https://example.com/ai',
    },
    {
      title: 'Mobile & web',
      type: 'mobile-web',
      tagline: 'Responsive designs for any device',
      description: 'Build mobile-first web applications that provide seamless user experiences.',
      url: 'https://example.com/mobile-web',
    },
    {
      title: 'Spatial computing (VR/AR/MR)',
      type: 'spatial-computing',
      tagline: 'Experience reality like never before',
      description: 'Dive into immersive worlds with virtual, augmented, and mixed reality technologies.',
      url: 'https://example.com/spatial-computing',
    },
    {
      title: 'Smart devices (IoT)',
      type: 'iot',
      tagline: 'Connecting the world around you',
      description: 'Innovate with IoT solutions that improve everyday life through connectivity.',
      url: 'https://example.com/iot',
    },
  ];
}

// Fetch works when the component is mounted
onMounted(() => {
  const stopOrientationListener = setupOrientationListener((newOrientation: any) => {
    orientation.value = newOrientation;

    // Optional: Update body class for global CSS adjustments
    document.body.classList.remove('portrait', 'landscape');
    document.body.classList.add(newOrientation);
  });

  onUnmounted(() => {
    stopOrientationListener();
  });

  fetchWorks(); // Call fetchWorks function
  getExpertiseData();
  loadPreferencesFromLocalStorage();

  // check url for hash

  setTimeout(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(window.location.search);
    const slug = params.get('slug');
    const targetId = hash ? hash.slice(1) : slug;

    if (targetId) {
      const element = document.getElementById(targetId);
      if (element) {
        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: element,
            offsetY: 1000,
          },
          ease: 'power2.out',
          onComplete: () => {
          // remove params from url
            window.history.replaceState(
              {},
              '',
              window.location.pathname
            );
          }
        });
      }
    }
  }, 500);

  // check url for params
  // checkParams();

});

function checkParams() {
  const params = new URLSearchParams(window.location.search);
  if (params.has('sentry_test')) {
    const sentry_test = params.get('sentry_test');
    if (sentry_test === '1') {
      throw new Error('💥 Sentry test crash via URL param')
    }
  }
}

const loadPreferencesFromLocalStorage = () => {
  const savedPreferences = localStorage.getItem('cookiePreferences');
  if (savedPreferences) {
    showCookieBanner.value = false;
    //TODO: IDK what to do with this yet
    // const parsedPreferences = JSON.parse(savedPreferences);
  } else {
    showCookieBanner.value = true;
  }
};
</script>